const layoutTypes = {
  intrinsic: 'intrinsic',
  fixed: 'fixed',
  responsive: 'responsive',
  fill: 'fill',
};

export default layoutTypes;
